module.exports = __webpack_public_path__ + "static/media/wood-box.69904e97.jpg";